/**
 * @typedef {keyof typeof ignoredApiErrorCodes} IgnoredApiErrorCode
 * @typedef {keyof typeof ignoredApiStatusCodes} IgnoredApiStatusCode
 */

/**
 * A map of ignored API status codes.
 */
export const ignoredApiStatusCodes = {
  401: true,
  500: true,
};

/**
 * A map of ignored API error codes.
 */
export const ignoredApiErrorCodes = {
  // leave_post_overlap: true, // Example
  // remote_working_post_overlap: true,
};

/**
 * Captures a Sentry exception if the error code is not ignored.
 *
 * @param {import("axios").AxiosError} error
 */
export const isInSentryExceptionsAllowList = (error) => {
  const errorCode = error.response?.data?.code;
  const statusCode = error.response?.status;
  return ignoredApiErrorCodes[errorCode] || ignoredApiStatusCodes[statusCode];
};
